import { PageHeader, Icon } from "@evertrue/et-components";
import { useIdentity } from "base/identity-resolver";
import { PropTypes } from "base/react-libs";
import Resources from "./resources";
import Metrics from "./metrics";

import Upcoming from "./upcoming";
import RecommendedActions from "./recommended-actions/recommended-actions";
import { RecommendedActionsProvider } from "./recommended-actions/context/recommended-actions-context";


const HomepageMainContent = ({ setShowSettings }) => {
  const { user } = useIdentity();
  const userName = user.name.split(" ")[0];
  return (
    <>
      <div className="homepage-title-containter">
        <PageHeader title={`Welcome, ${userName}!`} className="homepage-title" />
      </div>
        <div className="homepage-settings-container">
          <Icon icon="gear" size={1} onClick={() => setShowSettings(true)} className="homepage-settings-icon" />
        </div>
    <div className="homepage-main-content">
      <Upcoming />
      <RecommendedActionsProvider>
        <RecommendedActions />
      </RecommendedActionsProvider>
      <Metrics />
      <Resources />
    </div>
    </>
  );
};

HomepageMainContent.propTypes = {
  setShowSettings: PropTypes.func,
};

export default HomepageMainContent;
